import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

export const AlertHexIcon = ({ color, size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2 L20.66 7 V17 L12 22 L3.34 17 V7 Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M12 8v5" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
    <circle cx="12" cy="16.3" r="1" fill={color} />
  </svg>
);

const ShowChangeDocButton = ({ tenantsChooseStore, style }) => {
  const theme = useTheme();
  const { t } = useTranslation("lobby");

  if (!tenantsChooseStore?.changeSignDocPdf) return null;

  return (
    <button
      type="button"
      onClick={() => tenantsChooseStore.openSignModal()}
      style={{
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        ...style,
      }}
    >
      <span
        style={{
          color: theme.color.primary,
          fontFamily: "Rubik",
          fontSize: 15,
          fontWeight: 500,
        }}
      >
        {t("changes_show_document")}
      </span>
      <span
        style={{
          width: 22,
          height: 22,
          borderRadius: 6,
          border: `1.5px solid ${theme.color.primary}`,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <svg width="7" height="11" viewBox="0 0 7 11" fill="none">
          <path
            d="M5.5 1L1 5.5 5.5 10"
            stroke={theme.color.primary}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
};

export default inject("tenantsChooseStore")(observer(ShowChangeDocButton));
